import React from 'react';
import {Banner} from '@albert-io/atomic';

interface Props {
  isCorrect: boolean;
}

const ResultIndicatorBar = ({isCorrect}: Props) => (
  <Banner type={isCorrect ? 'positive' : 'negative'} className='u-mar-b_2'>
    {isCorrect ? <Banner.Icon icon='check' /> : <Banner.Icon icon='times' />}
    <span>{isCorrect ? 'Correct' : 'Incorrect'}</span>
  </Banner>
);

export default ResultIndicatorBar;
